import { css } from '@emotion/css';

export const dialogNoPinContainer = css`
  text-align: center;

  .dialog-content {
    font-size: 14px;
    line-height: 1.33;
    color: #5e5e5e;
    padding-bottom: 20px;
  }
`;
